import { type FormModelField } from '../form.field';
import { type FormModelFieldSubForm } from './form.subform';

export function getOtherAssignedSubformFieldIds(
	field: FormModelField,
	...excludeIds: (string | undefined)[]
): string[] {
	const stateValue = field.parent?.stateValue;
	if (!stateValue) return [];

	const allIds: string[] = [];

	if (stateValue.anchorTypeState) {
		allIds.push(...Object.values(stateValue.anchorTypeState).filter((id): id is string => !!id));
	}
	if (stateValue.equipmentTypeState) {
		allIds.push(...Object.values(stateValue.equipmentTypeState).filter((id): id is string => !!id));
	}
	if (stateValue.spanTypeState) {
		allIds.push(...Object.values(stateValue.spanTypeState).filter((id): id is string => !!id));
	}

	const excludeSet = new Set(excludeIds.filter((id): id is string => id != null));
	return allIds.filter((id) => !excludeSet.has(id));
}

export function getSubformPath(field: FormModelField): FormModelFieldSubForm[] {
	const path: FormModelFieldSubForm[] = [];
	let current = field.parent;

	while (current?.parent != null) {
		path.unshift(current);
		current = current.parent;
	}

	return path;
}
